<template>
  <div class="singleSiteOutEcharts">
    <div class="margin-right-40">
      <!-- 单个站点--站点信息 -->
      <!-- 表格 -->
      <div class="leftPanel">
        <!-- <LeftSiteInformation :userList="siteInfoList" :bigtitle="siteInfoTitle"/> -->
        <!-- 可用电池信息 -->
        <!-- <UserfulBatteryBar class="flex1" style="margin-top:30px;"/> -->
      </div>
    </div>
    <div>
      
      
      <!-- 运营 -->
      <div class="singlesite-operate">
        <div class="flex">
          <!-- 高峰期排队-->
          <!-- <QueueEchart class="flex1"/> -->
          <!-- 需求及电价 -->
          <!-- <DemandAndPrice class="flex1" style="margin-top:60px;"/> -->
        </div>
        <OperationalIndicators :userList="userList"/>
        <div class="flex">
          <!-- 电池配置及负荷率 -->
          <!-- <BatteryAndLoadRate class="flex1"/> -->
          <!-- 充电成本趋势 -->
          <!-- <ChargeCostTrend class="flex1"/> -->
        </div>
      </div>
    </div>
    <div>
      <!-- 单个站点--考核指标 -->
      <!-- <taskIndicators/>   -->
      <!-- <EvaluationIndicators :userList="userList"/> -->
      <div class="margin-bottom-xl singlesite-operate">
        <!-- 运营业务收入 -->
        <!-- <OperateIncome/> -->
        <div class="flex">
          <!-- 订单趋势 -->
          <!-- <OrderTrend class="flex1"/> -->
          <!-- 运营成本 -->
          <!-- <OperateCost class="flex1"/> -->
        </div>
      </div>

    </div>
  </div>
</template>

<script>

//用户指标
import LeftSiteInformation from "@/views/singleSite/leftSiteInformation";
// 可用电池信息
import UserfulBatteryBar from "@/components/echart/singleSiteCharts/userfulBatteryBar";
// 每月高峰期排队数
import QueueEchart from "@/components/echart/singleSiteCharts/queueEchartBar";
//考核指标一
import taskIndicators from "@/views/singleSite/evaluationIndex";
// 运营业务收入
import OperateIncome from "@/components/echart/singleSiteCharts/operateIncome.vue";
//订单趋势
import OrderTrend from "@/components/echart/singleSiteCharts/orderTrendLine";
//运营成本
import OperateCost from "@/components/echart/singleSiteCharts/operateCostLine";
//考核指标
import EvaluationIndicators from "@/components/common/evaluationIndicators";
//运营指标
import OperationalIndicators from "@/components/common/operationalIndicators";

//需求及电价
import DemandAndPrice from "@/components/echart/singleSiteCharts/demandAndPrice";
// 电池配置及负荷率
import BatteryAndLoadRate from "@/components/echart/singleSiteCharts/batteryAndLoadRate";
// 充电成本趋势
import ChargeCostTrend from "@/components/echart/singleSiteCharts/chargeCostTrend";


import {formatTime} from '@/utils/index'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      options: {},
      // 站点信息
      //标题
      siteInfoTitle:{
        CHN:'站点信息',
        ENG:'Site information'
      },
      //展示数据
      siteInfoList : [{
        key:'站点名称',
        value:''
      },{
        key:'建站日期',
        value:""
      },{
        key:'省市',
        value:""
      },{
        key:'开站日期',
        value:""
      },{
        key:'占地面积',
        value:""
      },{
        key:'服务能力',
        value:"336车次/天"
      },{
        key:'匹配车型',
        value:""
      },{
        key:'站点类型',
        value:""
      },{
        key:'车位数量',
        value:""
      },{
        key:'额定电池数',
        value:""
      }],

      //车辆指标
      //标题
      carIndicatorsTitle:{
        CHN:'车辆指标',
        ENG:'Car indicators'
      },
      //展示数据
      carIndicatorsList:[{
        counts:0,
        text:"换电车辆数"
      },{
        counts:0,
        text:"单车日均换电次数"
      },{
        counts:0,
        text:"本月新增车辆数"
      },{
        counts:0,
        text:"单车日均换电里程"
      }],
      userList:[{},{},{},{}],
      //用户指标
      selectUserTarget:{},
    };
  },
  components: {
    LeftSiteInformation,
    UserfulBatteryBar,
    QueueEchart,
    taskIndicators,
    OperateIncome,
    OrderTrend,
    OperateCost,
    EvaluationIndicators,
    OperationalIndicators,
    DemandAndPrice,
    BatteryAndLoadRate,
    ChargeCostTrend,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    // 刷新接口需要每个子组件封装一个getData();
    getData(data){
      this.selectStationDetail(data);
    },
    //TiDB-站点-站点信息
    selectStationDetail(data={}){
      let _this = this;
      let params = {
          "enCode":"TiDB-zhandian-zhandianxinxixia",
          "@station_id":data.stationId
        }
        dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          console.log("站点信息下",res)
          _this.siteInfoList = [{
            key:'站点名称',
            value:res.stationName
          },{
            key:'建站日期',
            value:formatTime(res.constructionTime,'yyyy-MM-dd')
          },{
            key:'省市',
            value:res.province+res.city+res.region
          },{
            key:'开站日期',
            value:formatTime(res.creationDate,'yyyy-MM-dd')
          },{
            key:'占地面积',
            value:res.coverAnArea+'平米'
          },{
            key:'服务能力',
            value:res.stationServiceQuality+"车次/天"
          },{
            key:'匹配车型',
            value:res.vehicleBrand
          },{
            key:'站点类型',
            // 0  乘用车  1 商用车
            value:res.stationType
          },{
            key:'车位数量',
            value:res.parkingPlace+'个'
          },{
            key:'额定电池数',
            value:(res.houseTotalBatteries||'')+'块'
          }]
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
</style>